module.exports = __webpack_public_path__ + "img/6.8d7381fd.png";